import LamanteShell from 'src/components/site/shells/LamanteShell';
import { coreSiteRoutes } from 'src/config/sites/coreRoutes';
import { createModuleInit } from './moduleInit';
import { SiteDefinition } from './SiteDefinition';

const lamanteSite: SiteDefinition = {
    id: 'lamante',
    label: "L'Amante Classic",
    description: 'Primary customer experience with full navigation and business logic.',
    routes: coreSiteRoutes,
    shell: LamanteShell,
    init: createModuleInit(),
};

export default lamanteSite;
